import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJAIPhotoEditorPresetList from '../view/FJAIPhotoEditorPresetList';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor';

const FJAIPhotoEditorPresetListContainer = () => {
    const dispatch = useDispatch();

    const selectedPreset = useSelector(state => state.aiPhotoEditor.selectedPreset);
    const availablePresets = useSelector(state => state.aiPhotoEditor.availablePresets);
    const promptStatus = useSelector(state => state.aiPhotoEditor.promptStatus);

    const handlePresetSelect = useCallback(
        preset => {
            dispatch(FJActionAIPhotoEditor.selectPresetAction(preset));
        },
        [dispatch],
    );

    return (
        <FJAIPhotoEditorPresetList
            value={selectedPreset}
            onChange={handlePresetSelect}
            options={availablePresets}
            promptStatus={promptStatus}
        />
    );
};

export default FJAIPhotoEditorPresetListContainer;
